module.exports = __webpack_public_path__ + "static/image0000-e516d74db53ac0d41a4329133fead3ae.jpg";